// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/shared/colors.css\"","ot_grayLt":"#eef3f7","ot_grayMidLt":"#ccc","seriesModal":"seriesModal__seriesModal___uiLuq","seriesModalTouch":"seriesModal__seriesModalTouch___2eguR seriesModal__seriesModal___uiLuq","seriesModalMenu":"seriesModal__seriesModalMenu___1K0vf seriesModal__seriesModalTouch___2eguR seriesModal__seriesModal___uiLuq","backBtn":"seriesModal__backBtn___vvbNK","seriesModalWelcome":"seriesModal__seriesModalWelcome___1AS3Q seriesModal__seriesModalTouch___2eguR seriesModal__seriesModal___uiLuq","inputSeries":"seriesModal__inputSeries___Q6EU0"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/series/modals/seriesModal.css
// module id = 991
// module chunks = 0